import {GetStaticProps, InferGetStaticPropsType} from "next"

import {getAllCourses} from "datasources/datocms/query"
import type {GetCoursesQuery} from "generated/datocms"
import datocms from "datasources/datocms"

import {withLayout} from "components/Layout"

// test

import {CoursesProgressPage, CoursesProgressPageProps} from "components/Courses/CourseProgress"

export const getStaticProps: GetStaticProps<CoursesProgressPageProps> = async () => {
  const {allCourses: courses} = await datocms<GetCoursesQuery>(getAllCourses, {
    filter: {
      state: {
        in: ["active", "preparing"]
      }
    }
  })

  return {
    props: {courses, ongoingCourseId: null, isAuthenticated: false, knownCourses: null},
    revalidate: 60
  }
}

export default withLayout(CoursesProgressPage, {isPage: true})
